import React, { useEffect, useState } from "react"
import styled from "styled-components"
import Chevron from "./svg/chevron"
import Foots from "./svg/foots"
import Moon from "./svg/moon"
import Cutlery from "./svg/cutlery"
import PropTypes from "prop-types"
import InputNumber from "@src/components/reusable/forms/input-number"

const ItineraryBoxWrapper = styled.div`
  border-radius: 6px;
  border: 1px solid rgba(30, 30, 30, 0.15);
  padding: 32px 28px;
  width: 100%;

  @media (max-width: 660px) {
    border: none;
    border-radius: 0;
    padding: 24px 0;
    border-top: 1px solid rgba(30, 30, 30, 0.15);
    padding-bottom: 0;
  }

  padding-bottom: ${props => (props.$isExpanded ? "24px" : "0")};
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`

const RowHeader = styled(Row)`
  margin-bottom: 16px;
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  & .input-number {
    justify-self: end;
    flex-direction: row;
    align-items: center;
    & > label {
      margin: 0 8px 0 0;
    }
    & > div {
      width: 80px;
      padding: 2px 4px;
      & > button {
        height: 8px;
      }
    }
  }
`

const RowContent = styled(Row)`
  display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
  gap: 16px;
  @media (max-width: 600px) {
    padding-bottom: 24px;
  }
  @media (max-width: 1950px) {
    flex-direction: column;
  }
`

const Day = styled.div`
  border-radius: 21px;
  background: ${props => props.theme.secondary900};
  color: #fbf8f5;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.25px;
  padding: 4px 12px;
  width: 100px;
  text-align: center;
`

const Title = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 8px;
  grid-column: 1 / 3;
  display: flex;
  justify-content: space-between;
`

const Description = styled.div`
  color: ${props => props.theme.grayShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  width: 50%;
  @media (max-width: 1950px) {
    width: 100%;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  gap: 8px;
  @media (max-width: 1950px) {
    width: 100%;
  }
`

const Perk = styled.div`
  display: flex;
  color: ${props => props.theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  gap: 8px;
  b {
    font-weight: 700;
    margin-right: 8px;
  }
  svg {
    min-width: 24px;
  }
`

const ChevronHolder = styled.span`
  transition: all 0.2s;
  transform: rotate(${props => (props.$isExpanded ? "180deg" : "0deg")});
  cursor: pointer;
  margin-left: 4px;
`

const PerkText = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  @media (max-width: 600px) {
    gap: 0;
  }
`

const ItineraryBox = ({
  itinerary,
  index,
  expandAll,
  dayLabel,
  onNightChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(prev => !prev)
  }

  useEffect(() => {
    if (expandAll) {
      setIsExpanded(true)
    }
  }, [expandAll])
  const handleNightChange = newValue => {
    if (onNightChange) {
      onNightChange(index, newValue)
    }
  }
  return (
    <ItineraryBoxWrapper $isExpanded={isExpanded}>
      <RowHeader>
        <Day>{dayLabel}</Day>
        <InputNumber
          label="Nights"
          name={`nights.day_${index + 1}`}
          min={1}
          max={10}
          required={true}
          defaultValue={1}
          onValueChange={handleNightChange}
        />
        <Title>
          {itinerary?.title}{" "}
          <ChevronHolder $isExpanded={isExpanded} onClick={toggleExpand}>
            <Chevron />
          </ChevronHolder>
        </Title>
      </RowHeader>

      <RowContent $isVisible={isExpanded}>
        <Description>
          {itinerary?.details.replaceAll("<p>", "").replaceAll("</p>", "")}
        </Description>
        <Column>
          <Perk>
            <Foots />{" "}
            <PerkText>
              <b> Distance</b>{" "}
              {itinerary?.attributes && itinerary?.attributes[1]?.value}
            </PerkText>
          </Perk>
          <Perk>
            <Moon />{" "}
            <PerkText>
              <b> Overnight Location</b>{" "}
              {itinerary?.attributes && itinerary?.attributes[0]?.value}
            </PerkText>
          </Perk>
          <Perk>
            <Cutlery />{" "}
            <PerkText>
              <b> Included Meals</b>{" "}
              {itinerary?.attributes && itinerary?.attributes[2]?.value}
            </PerkText>
          </Perk>
        </Column>
      </RowContent>
    </ItineraryBoxWrapper>
  )
}

ItineraryBox.PropTypes = {
  itinerary: PropTypes.object.isRequired,
  expandAll: PropTypes.bool.isRequired,
}

export default ItineraryBox
